"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_gyroscope__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "8739b54d-fd97-4f3f-b7b7-192287d61bbf",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "gyroscope-hi"), /*#__PURE__*/React.createElement("g", {
    id: "74023b6b-8cb4-47bb-bb05-9e2fdb8109b4",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,32.88",
    transform: "translate(0 -0.02)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 96.02,
    rx: 95.1,
    ry: 33.56,
    transform: "translate(-39.78 95.98) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 96.02,
    rx: 33.56,
    ry: 95.1,
    transform: "translate(-39.78 95.98) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,138.67c-29.39,22.88-56.91,32.82-67.25,22.49-2.56-2.57-3.87-6.19-4.06-10.63-.19,5.41,1.1,9.78,4.06,12.74,10.34,10.34,37.86.39,67.25-22.49,29.39,22.88,56.91,32.83,67.25,22.49,3-3,4.25-7.33,4.06-12.74-.19,4.44-1.5,8.06-4.06,10.63C152.91,171.49,125.39,161.55,96,138.67Z",
    transform: "translate(0 -0.02)",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 24.02,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,117.87A24,24,0,0,1,72,94.93c0,.37,0,.73,0,1.09a24,24,0,1,0,48,0c0-.36,0-.72,0-1.09A24,24,0,0,1,96,117.87Z",
    transform: "translate(0 -0.02)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,51.26A263.3,263.3,0,0,0,51.24,96a255.16,255.16,0,0,0,21,23.73,257.75,257.75,0,0,0,23.73,21,256.44,256.44,0,0,0,23.73-21,255.16,255.16,0,0,0,21-23.73,257.75,257.75,0,0,0-21-23.73A256.44,256.44,0,0,0,96,51.26Z",
    transform: "translate(0 -0.02)"
  }))));
}

var _default = ic_gyroscope__dark;
exports.default = _default;